<template>
    <div class="alert" :class="alertClass">
        {{ alertMsg }}
        <span class="close" @click.prevent="dismiss()">&times;</span>
    </div>
</template>

<script>
    import useAlerts from '../../shared/composables/useAlerts';

	//Component idea taken from https://www.digitalocean.com/community/tutorials/vuejs-vue-modal-component
    export default {
        name: 'Alert',
		props: {
            alertIdx: Number,
            alertMsg: String,
			alertClass: String,
            dismissTimeout: Number
		},
		setup ({ alertIdx, dismissTimeout }) {
            const { removeAlert } = useAlerts();

            if (dismissTimeout) {
                setTimeout(() => {
                    dismiss();
                }, dismissTimeout);
            }

            const dismiss = () => {
                removeAlert(alertIdx)
            }

            return {
                // showAlert,
                dismiss
            }
		}
    };
</script>

<style scoped>
    .alert {
        margin-bottom: 10px;
    }
    .alert:last-of-type {
        margin-bottom: 35px;
    }
</style>
